module.exports = require("chained-function");


//////////////////
// WEBPACK FOOTER
// external "chained-function"
// module id = 5
// module chunks = 0